import React from "react";

function Mycontact(){
    return (
        <section id="contact">
            <h2>Contact</h2>
            <div className="contact-layout">
                <article className='contact-card contact-info-card'>
                    <h3>Get In Touch</h3>
                    <p className="contact-intro">
                        I am open to internships, collaborations, and frontend opportunities.
                    </p>

                    <p className="contact-item">
                        <span className="contact-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24">
                                <path d="M3 6.75A2.75 2.75 0 0 1 5.75 4h12.5A2.75 2.75 0 0 1 21 6.75v10.5A2.75 2.75 0 0 1 18.25 20H5.75A2.75 2.75 0 0 1 3 17.25V6.75zm2.17-.14 6.3 5.24a.8.8 0 0 0 1.03 0l6.3-5.24a1.25 1.25 0 0 0-.55-.11H5.75c-.2 0-.4.04-.58.11zm14.08 2.02-5.8 4.82a2.3 2.3 0 0 1-2.9 0l-5.8-4.82v8.62c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V8.63z" />
                            </svg>
                        </span>
                        <span>
                            <strong>Email</strong>
                            <a href="mailto:dharshuvj2611@gmail.com">dharshuvj2611@gmail.com</a>
                        </span>
                    </p>

                    <p className="contact-item">
                        <span className="contact-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24">
                                <path d="M4.98 3.5A1.48 1.48 0 0 0 3.5 4.98v14.04c0 .82.66 1.48 1.48 1.48h14.04c.82 0 1.48-.66 1.48-1.48V4.98c0-.82-.66-1.48-1.48-1.48H4.98zm4.46 14.2H6.65V9h2.79v8.7zM8.04 7.8a1.62 1.62 0 1 1 0-3.24 1.62 1.62 0 0 1 0 3.24zM17.35 17.7h-2.78v-4.23c0-1-.02-2.3-1.4-2.3s-1.62 1.1-1.62 2.22v4.3H8.77V9h2.67v1.2h.04c.37-.7 1.28-1.43 2.63-1.43 2.81 0 3.33 1.85 3.33 4.26v4.67z" />
                            </svg>
                        </span>
                        <span>
                            <strong>LinkedIn</strong>
                            <a href="https://www.linkedin.com/in/yoga-dharshini-5b6542293/" target="_blank" rel="noreferrer">
                                linkedin.com/in/yoga-dharshini-5b6542293
                            </a>
                        </span>
                    </p>

                    <p className="contact-item">
                        <span className="contact-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24">
                                <path d="M12 .8a11.2 11.2 0 0 0-3.54 21.83c.56.1.76-.24.76-.54v-1.9c-3.1.67-3.75-1.32-3.75-1.32-.5-1.28-1.24-1.62-1.24-1.62-1.01-.69.08-.68.08-.68 1.12.08 1.7 1.15 1.7 1.15.99 1.7 2.6 1.21 3.23.92.1-.72.39-1.21.7-1.49-2.47-.28-5.06-1.24-5.06-5.52 0-1.22.44-2.22 1.15-3-.11-.28-.5-1.42.11-2.96 0 0 .95-.3 3.1 1.15a10.8 10.8 0 0 1 5.64 0c2.15-1.45 3.1-1.15 3.1-1.15.61 1.54.22 2.68.11 2.96.72.78 1.15 1.78 1.15 3 0 4.3-2.6 5.24-5.09 5.51.4.35.75 1.03.75 2.09v3.09c0 .3.2.65.77.54A11.2 11.2 0 0 0 12 .8z" />
                            </svg>
                        </span>
                        <span>
                            <strong>GitHub</strong>
                            <a href="https://github.com/Dharshini-26003" target="_blank" rel="noreferrer">
                                github.com/Dharshini-26003
                            </a>
                        </span>
                    </p>
                </article>
            </div>
        </section>
    );
 
}
export default Mycontact;
